import React, {useContext} from 'react';
import tiro_blanco from '../../images/tiro_blanco.png';
import eye_vision from '../../images/eye_vision.png';
import { useCompanyVisit } from '../Company_visitContext';
import { CompanyContext } from '../CompanyContext';

export const VisitasMision = ({infoCompany}) => {
  const missionData = infoCompany?.view_mission || [];
  const icons = [tiro_blanco, eye_vision];

  return (
    <div className='mision-company'>
      <div className="title-mision">
        <h2 style={{ textDecorationColor:'var(--theme-visit)' }}>Misión de la empresa</h2>
      </div>

      <div className='content-card-mision'>
        {missionData.map((item, index) => (
          <div className='card-mision-company' style={{ border:`15px solid var(--theme-visit)` }} key={index}>
            <div className='article-mision'>
              <img src={icons[index] || tiro_blanco} alt="icono mision" />
              <h3>{item.title}</h3>
              <h5> {/* falta aca */} </h5>
              <p>{item.text}</p>
            </div>
            <div className='circle-number' style={{ backgroundColor:'var(--theme-visit)' }}>
              <span>{String(index + 1).padStart(2, '0')}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
